var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid px-sm-0 px-md-5"},[_c('div',{staticClass:"d-flex px-sm-0 my-3"},_vm._l((_vm.navs),function(nav,index){return _c('vs-button',{key:index,staticStyle:{"margin":"8px !important","margin-bottom":"5px","padding":"4px"},attrs:{"active":_vm.activeNav == index,"size":"small","danger":"","border":""},on:{"click":function($event){return _vm.navChange(index)}}},[_vm._v(" "+_vm._s(nav.title)+" ")])}),1),_c('div',[(_vm.galleryData.data)?_c('VueJustifiedLayout',{attrs:{"items":_vm.galleryData.data,"options":{
  containerPadding: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  forceAspectRatio: 0,
  fullWidthBreakoutRowCadence:0,
  showWidows: true,
  targetRowHeight:280,
  boxSpacing:3
}},scopedSlots:_vm._u([{key:"default",fn:function({ item, index }){return [(_vm.loader)?_c('router-link',{attrs:{"to":{
            name: 'details',
            params: { id: item.id },
            query: {
              image: item.image,
              height: item.height,
              width: item.width,
              pres: (item.height / item.width) * 100,
            },
          }}},[_c('img',{staticClass:"animate__animated animate__fadeIn",style:(`animation-delay:.${index}s`),attrs:{"src":'https://pic.imamhussain.org/photos/preview/' + item.image,"width":"100%","alt":item.image}})]):_vm._e()]}}],null,false,1816881939)}):_vm._e()],1),_c('div',{staticClass:"row justify-content-center animate__animated animate__fadeInUp my-3"},[(_vm.galleryData.next_page_url !=null)?_c('vs-button',{attrs:{"color":"rgb(211, 186, 127)","flat":"","gradient":"","loading":_vm.loading,"size":"large"},on:{"click":_vm.loadMore}},[_vm._v(" تحميل المزيد ")]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }